import { format } from 'date-fns'
import { t } from 'i18next'
import Linkify from 'linkify-react'
import React from 'react'
import { Trans } from 'react-i18next'

import { isValidUrl } from '../../common/helpers.js'
import { CommonSubscriptionValueProduct } from '../../common/models/common-subscription-value-product.js'
import { SubscriptionDTO, SubscriptionProductDTO } from '../../common/types.js'
import { formatPrice } from '../../common/utils/utils.js'
import { PlanCardProps } from '../components-hydrated/plan-cards/plan-cards.js'
import { Button } from '../components/button/button.js'
import { FlexLogo } from '../components/flex-logo/flex-logo.js'
import { FlexIcon } from '../components/icon/icon.js'
import { Image, ImageProps } from '../components/image/image.js'
import { ListItemProps } from '../components/list/src/list-item.js'
import { ModalContent } from '../components/modal/src/modal-content.js'
import { ModalHeader } from '../components/modal/src/modal-header.js'
import { ModalTrigger } from '../components/modal/src/modal-trigger.js'
import { Modal } from '../components/modal/src/modal.js'
import { ProductProps } from '../components/product/product.js'
import { Separator } from '../components/separator/separator.js'
import i18n from '../i18n.js'
import { View } from '../types.js'
import { getCommonSubscriptionCardDetailListItems } from './subscription-product-common.js'
import { Subscription } from './subscription.js'

export class SubscriptionValueProduct extends CommonSubscriptionValueProduct {
    readonly subscription: Subscription

    constructor(product: SubscriptionProductDTO, subscription: Subscription) {
        super(product, subscription.currencySymbol, subscription.locale)
        this.subscription = subscription
    }

    image(width = 40): JSX.Element {
        const url = isValidUrl(this.data.product?.imageUrl)
        if (url) {
            const imageProps: ImageProps = {
                role: 'presentation',
                srcset: `${url.toString()} ${width}w, ${url.toString()} ${width * 2}w`,
                width,
            }

            return <Image {...imageProps} className="product__image" />
        }

        return <FlexLogo width={width} />
    }

    planCard(view: View): PlanCardProps {
        const current = this.plan.id === view.state.selectedPlan
        const paragraphs = i18n.t(`plans.plans.${this.plan.code}.accordion.paragraphs`, { returnObjects: true })
        const tradeInDiscount = this.subscription.data.nonQueryableMeta.estimatedTradeInValue
        let minimalCost = this.minimalTotalCost

        if (this.overrideTotalMinimalCost) {
            minimalCost = this.overrideTotalMinimalCost
        }

        return {
            title: i18n.t(`plans.plans.${this.plan.code}.title`, {
                months: this.plan.duration,
            }),
            description: this.renderDescription(),
            price: this.displayedPrice,
            priceDescription: this.priceDescription,
            tradeInDiscount: tradeInDiscount ? (
                <p>
                    <b>{i18n.t(`plans.tradeInTitle`)}</b>
                    <br />
                    {i18n.t(`plans.tradeIn`, {
                        amount: formatPrice(tradeInDiscount / (this.plan.duration || 24), this.currencySymbol),
                        duration: this.plan.duration || 24,
                    })}
                </p>
            ) : undefined,
            buttonId: 'btn-select-value-plan',
            buttonText: current ? i18n.t(`plans.selected`) : i18n.t(`plans.select`),
            isDisabled: current,
            children: '',
            id: `plan-selection-${this.plan.uuid}`,
            labelText: i18n.t(`plans.plans.${this.plan.code}.title`, {
                months: this.plan.duration,
            }),
            minimumCost: i18n.t(`plans.minimumTotalCost`, {
                cost: formatPrice(minimalCost, this.currencySymbol),
            }),
            value: this.plan.id,
            accordion: {
                title: i18n.t(`plans.plans.${this.plan.code}.accordion.title`, {
                    months: this.plan.duration,
                }),
                content: this.renderParagraphs(paragraphs as { title: string; content: string }[]),
            },
        }
    }

    renderTooltipModalTrigger(key: string): JSX.Element {
        return (
            <>
                &nbsp;
                <ModalTrigger>
                    <Button
                        className="button--modal-trigger"
                        text={i18n.t(`plans.plans.${this.plan.code}.${key}.modal.trigger`)}
                        style="link"
                    />
                </ModalTrigger>
            </>
        )
    }

    renderTooltipModal(key: string): JSX.Element {
        const paragraphs = i18n.t(`plans.plans.${this.plan.code}.${key}.modal.paragraphs`, { returnObjects: true })

        return this.getModal(paragraphs as { title: string; content: string }[], key)
    }

    renderDescription() {
        return (
            <ul className="list text-small bold">
                <li>
                    {i18n.t(`plans.plans.${this.plan.code}.descriptionOne.title`)}
                    {/* <ModalProvider>
                        <Tooltip
                            trigger={(
                                <Button
                                    element="span"
                                    className="button--modal-trigger"
                                    text={i18n.t(`plans.plans.${this.plan.code}.descriptionOne.title`)}
                                    iconRight={InfoIcon}
                                    style="link"
                                />
                            )}
                        >
                            <div className="text text-small">
                                <h3>{i18n.t(`plans.plans.${this.plan.code}.descriptionOne.title`)}</h3>
                                <p className="text__margin-half">
                                    {i18n.t(`plans.plans.${this.plan.code}.descriptionOne.tooltip`)}
                                    {i18n.exists(`plans.plans.${this.plan.code}.descriptionOne.modal`) && this.renderTooltipModalTrigger('descriptionOne')}
                                </p>
                            </div>
                        </Tooltip>
                        {i18n.exists(`plans.plans.${this.plan.code}.descriptionOne.modal`) && this.renderTooltipModal('descriptionOne')}
                    </ModalProvider> */}
                </li>
                <li>
                    {i18n.t(`plans.plans.${this.plan.code}.descriptionTwo.title`)}
                    {/* <ModalProvider>
                        <Tooltip
                            trigger={(
                                <Button
                                    element="span"
                                    className="button--modal-trigger"
                                    text={i18n.t(`plans.plans.${this.plan.code}.descriptionTwo.title`)}
                                    iconRight={InfoIcon}
                                    style="link"
                                />
                            )}
                        >
                            <div className="text text-small">
                                <h3>{i18n.t(`plans.plans.${this.plan.code}.descriptionTwo.title`)}</h3>
                                <p className="text__margin-half">
                                    {i18n.t(`plans.plans.${this.plan.code}.descriptionTwo.tooltip`)}
                                    {i18n.exists(`plans.plans.${this.plan.code}.descriptionTwo.modal`) && this.renderTooltipModalTrigger('descriptionTwo')}
                                </p>
                            </div>
                        </Tooltip>
                        {i18n.exists(`plans.plans.${this.plan.code}.descriptionTwo.modal`) && this.renderTooltipModal('descriptionTwo')}
                    </ModalProvider> */}
                </li>
                <li>
                    {i18n.t(`plans.plans.${this.plan.code}.descriptionThree.title`)}
                    {/* <ModalProvider>
                        <Tooltip
                            trigger={(
                                <Button
                                    element="span"
                                    className="button--modal-trigger"
                                    text={i18n.t(`plans.plans.${this.plan.code}.descriptionThree.title`)}
                                    iconRight={InfoIcon}
                                    style="link"
                                />
                            )}
                        >
                            <div className="text text-small">
                                <h3>{i18n.t(`plans.plans.${this.plan.code}.descriptionThree.title`)}</h3>
                                <p className="text__margin-half">
                                    {i18n.t(`plans.plans.${this.plan.code}.descriptionThree.tooltip`)}
                                    {i18n.exists(`plans.plans.${this.plan.code}.descriptionThree.modal`) && this.renderTooltipModalTrigger('descriptionThree')}
                                </p>
                            </div>
                        </Tooltip>
                        {i18n.exists(`plans.plans.${this.plan.code}.descriptionThree.modal`) && this.renderTooltipModal('descriptionThree')}
                    </ModalProvider> */}
                </li>
            </ul>
        )
    }

    renderParagraphs = (paragraphs: { title: string; content: string }[]) => {
        if (!Array.isArray(paragraphs)) {
            return null
        }

        return (
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore ReactI18N type definition issue
            <Linkify options={{ target: '_blank' }}>
                {paragraphs.map((paragraph, index) => {
                    if (paragraph.title && !paragraph.content) {
                        return <h2 key={index}>{paragraph.title}</h2>
                    } else if (paragraph.title && paragraph.content) {
                        return (
                            <div className="text" key={index}>
                                <h3>{paragraph.title}</h3>
                                <p className="text-small text__margin-half">{paragraph.content}</p>
                                <Separator />
                            </div>
                        )
                    } else {
                        return (
                            <div className="text text__margin-half" key={index}>
                                <p className="text-small">{paragraph.content}</p>
                                <Separator />
                            </div>
                        )
                    }
                })}
            </Linkify>
        )
    }

    private getModal(paragraphs: { title: string; content: string }[], key: string) {
        const modalProps = {
            customCloseButton: {
                id: 'btn-close-value-plan-modal',
                text: i18n.t('plans.closeModal'),
            },
        }

        return (
            <Modal {...modalProps}>
                <ModalHeader>
                    <h1>{i18n.t(`plans.plans.${this.plan.code}.${key}.title`)}</h1>
                </ModalHeader>
                <ModalContent>
                    <div className="text">{this.renderParagraphs(paragraphs)}</div>
                </ModalContent>
            </Modal>
        )
    }

    getSubscriptionCardDetailListItems() {
        return getCommonSubscriptionCardDetailListItems(
            this,
            <strong>
                {t(`plans.plans.${this.plan.code}.title`, {
                    months: this.data.durationInMonths,
                })}
            </strong>,
            false,
            this.subscription.data.upgradeDate
                ? format(new Date(this.subscription.data.upgradeDate), 'dd.MM.yyyy')
                : undefined,
        )
    }

    getSubscriptionCardListItems() {
        const items: ListItemProps[] = [
            {
                children: (
                    <strong>
                        {t(`plans.plans.${this.plan.code}.title`, {
                            months: this.data.durationInMonths,
                        })}
                    </strong>
                ),
                icon: FlexIcon,
            },
        ]
        if (this.subscription.hasEnded) {
            items.push({
                children: (
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore ReactI18N type definition issue
                    <Trans i18nKey="subscription.endedDate">
                        Ended{' '}
                        <strong
                            dangerouslySetInnerHTML={{
                                __html: this.subscription.formattedContractEndDate,
                            }}
                        ></strong>
                    </Trans>
                ),
            })
        } else {
            if (this.subscription.formattedUpgradeDate) {
                items.push({
                    children: (
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore ReactI18N type definition issue
                        <Trans i18nKey="subscription.upgradeFrom">
                            Eligible for upgrade from{' '}
                            <strong
                                dangerouslySetInnerHTML={{
                                    __html: this.subscription.formattedUpgradeDate,
                                }}
                            ></strong>
                        </Trans>
                    ),
                })
            }

            items.push({
                children: <strong>{this.displayedPrice}</strong>,
            })
        }

        return items
    }

    getProductCard(
        subscriptionUuid: string,
        subscriptionDTO: SubscriptionDTO,
        contractStartDatetime: Date | null,
    ): ProductProps {
        const disclaimers = getSubscriptionUpgradeDisclaimers(subscriptionDTO)

        return {
            sku: this.sku,
            description: this.sku,
            nickname: this.data.nickname,
            content: this.data.product?.description,
            title: this.data.product?.translation?.name || '',
            variant: 'big',
            image: this.image(),
            meta: {
                product: this,
                subscriptionUuid,
                eligibleDate: subscriptionDTO.upgradeDate
                    ? format(new Date(subscriptionDTO.upgradeDate), 'dd.MM.yyyy')
                    : undefined,
                permissions: subscriptionDTO.permissions,
                uuid: subscriptionUuid,
                activeDate: contractStartDatetime ? format(new Date(contractStartDatetime), 'dd.MM.yyyy') : '',
            },
            disclaimers,
        }
    }
}

export const getSubscriptionUpgradeDisclaimers = (subscriptionDTO: SubscriptionDTO) => {
    const disclaimers = []
    if (!subscriptionDTO.permissions?.canUpgrade) {
        if (!subscriptionDTO.permissions?.parts?.canUpgrade?.isEligibleForUpgradeByDate) {
            disclaimers.push(t('existingSubscriptionStep.upgradeNotEligible.date'))

            return disclaimers
        }

        if (!subscriptionDTO.permissions?.parts?.baseRequirements?.noUnreceivedPreviousUpgrade) {
            disclaimers.push(t('existingSubscriptionStep.upgradeNotEligible.deviceNotReturned'))

            return disclaimers
        }

        if (!subscriptionDTO.permissions?.parts?.baseRequirements?.noPendingUpgrade) {
            if (subscriptionDTO.nonQueryableMeta.childPendingPaymentLink) {
                disclaimers.push(
                    <>
                        {t('existingSubscriptionStep.upgradeNotEligible.paymentPending')}{' '}
                        <a href={subscriptionDTO.nonQueryableMeta.childPendingPaymentLink}>
                            {t('existingSubscriptionStep.upgradeNotEligible.link')}
                        </a>
                    </>,
                )
            } else {
                disclaimers.push(t('existingSubscriptionStep.upgradeNotEligible.pendingUpgrade'))
            }
        }

        if (!subscriptionDTO.permissions?.parts?.baseRequirements?.noActiveClaim) {
            disclaimers.push(t('existingSubscriptionStep.upgradeNotEligible.activeClaim'))
        }

        if (disclaimers.length === 0) {
            disclaimers.push(t('existingSubscriptionStep.upgradeNotEligible.contactSupport'))
        }
    }

    return disclaimers
}
